/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "styled-components";
import Paper from "@material-ui/core/Paper";

const CustomPaper = (props: any) => <Paper {...props} />;

const StyledPaper = styled(CustomPaper)`
  ${({ theme }) => `
    padding: ${theme.spacing(3)}px;

    ${theme.breakpoints.down("sm")} {
      padding: ${theme.spacing(2)}px;
    }

    &.table-action-menu {
        padding: ${theme.spacing(0)}px;
    }
  `}
`;

export default StyledPaper;
